export const SYMBIOSIS_API_ENDPOINT = 'https://api.symbiosis.finance/crosschain';
